"use client";

import { ProductSpecification as UiProductSpecification } from "@jti/ui/components/ProductSpecification";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import type { ProductSpecificationProps } from "./ProductSpecification.inputs.builder";

export function ProductSpecification({ customAttributes }: ProductSpecificationProps) {
  const { __ } = useTranslations();

  const customAttributesList = customAttributes?.reduce<Record<string, string>>((result, { label, values }) => {
    if (!label || !values) return result;

    return Object.assign(result, {
      [label]: values
        .map(({ value }) => value)
        .filter(Boolean)
        .join(", "),
    });
  }, {});

  return <UiProductSpecification title={__("productspecification.title")} list={customAttributesList} />;
}
